export default "__VITE_ASSET__BJ7NdDPS__"